//SECTION RENDERING PDP SECTIONS
function updateSections() {
  const sectionIds = "fyre-pdp-product-content,fyre-pdp-video,main-product";
  // make request
  fetch(window.location.search + "&sections=" + sectionIds, {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    },
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      for (var single_section in json) {
        var updatedSectionHtml = json[single_section];
        var content = new DOMParser().parseFromString(
          updatedSectionHtml,
          "text/html"
        );
        var updatedContent = content.querySelector(
          "#" + single_section + " .update-content"
        );
        document.querySelector(
          "#" + single_section + " .update-content"
        ).innerHTML = updatedContent.innerHTML;

        //MAIN PRODUCT SPECIFIC
        if (single_section == "main-product") {
          var updatedVarTag = content.querySelector(
            "#main-product .product-card-badge-contained"
          );
          document.querySelector(
            "#main-product .product-card-badge-contained"
          ).innerHTML = updatedVarTag.innerHTML;

          var updatedShipWings = content.querySelector(
            "#main-product .shipping-wings-contained"
          );
          document.querySelector(
            "#main-product .shipping-wings-contained"
          ).innerHTML = updatedShipWings.innerHTML;
        }
      }

      //RE-INIT FOR VIDEO SEC
      videoClicker();
    })
    .catch((err) => {
      console.error(err);
    });
}
document
  .querySelector('input[name="id"]')
  .addEventListener("change", updateSections);

videoClicker();

function videoClicker() {
  var play_btn = document.querySelector("#play-vid");
  var play_btn_container = document.querySelector("#play-vid-container");

  play_btn.addEventListener("click", function () {
    play_btn_container.classList.add("active");
  });
}


//PDP SELECTS

// GET WINDOW WIDTH
var screenWidth = 99999;
function getScreenWidth() {
    screenWidth = window.innerWidth;
}

window.addEventListener('load', getScreenWidth);			  
window.addEventListener('resize', getScreenWidth);

const mobile_selects = document.querySelectorAll('.select-wrapper > combo-box');

var selects_observer = new MutationObserver(function(mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === "attributes") {
            selectsHideShowRewards();
        }
    });
});

//MOBILE SELECTS
mobile_selects.forEach((single_select) => {
    selects_observer.observe(single_select, {
        attributes: true //configure it to listen to attribute changes
    });
});

function selectsHideShowRewards() {
    const rewards_btn = document.querySelector('#smile-ui-container');
    if (screenWidth <= 740) {
        mobile_selects.forEach((single_select) => {
            if (single_select.hasAttribute('open')) {
                rewards_btn.style.opacity = "0";
                rewards_btn.style.visibility = "hidden";
                setTimeout(function () {
                    rewards_btn.style.display = "none";
                }, 1000);
            } else {
                rewards_btn.style.display = "block";
                setTimeout(function () {
                    rewards_btn.style.opacity = "1";
                    rewards_btn.style.visibility = "visible";
                }, 1000);
            }
        });
    }
}